import { css } from 'styled-components';

const notchlessStyles = css`
  & > .MuiOutlinedInput-notchedOutline {
    border: none;
  }
`;

export default notchlessStyles;
